import React from "react";
import DashboardResolver from "./dashboards/DashboardResolver";

const Home = () => {
  return <DashboardResolver />;
};

export default Home;
